import React from 'react'
import { ReactComponent as Loading } from './icons/spinner.svg'
import './styles.css'
function Button({ className = '', children, loading = false, loadingText = 'Processing ...', ...props }) {
  return (
    <button
      type="button"
      {...props}
      className={`h-[37px] px-[15px] lg:px-[30px] font-semibold text-center py-[8px] text-[14px] lg:text-[16px] text-white bg-[var(--brand-color)] rounded-[4px] ${
        loading ? 'opacity-50 pointer-events-none' : ''
      } ${props.disabled ? 'pointer-events-none opacity-40' : ''} ${className}`}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="spin mr-[8px]">
            <Loading />
          </div>
          {loadingText}
        </div>
      ) : (
        <div className='leading-[14px]'>{children}</div>
      )}
    </button>
  )
}

export default Button
